import React, { useEffect, useState } from "react";
import DropdownUniqueUsersInDisplayData from "../../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import DropdownTermDate from "../../../../unicomponents/Dropdowns/DropdownTermDate";
import DropdownHierarchyThree from "../../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import DropdownHierarchyTwo from "../../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyOne from "../../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownSchoolYear from "../../../../unicomponents/Dropdowns/DropdownSchoolYear";
import useLessons from "../../../../hooks/useLessons";
import useTagList from "../../../../hooks/useTagList";
import useFlexibleData from "../../../../hooks/useFlexibleData";
import { MdOutlineCancel } from "react-icons/md";
import { sumAllNumbersOfObject } from "../../../../util/dealingArrObj";
import { useUIContext } from "../../../../context/UIContext";
import { useAuthContext } from "../../../../context/AuthContext";
import { setTermIdByToday } from "../../../../util/dateRelated";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import SpecialSubjectContent from "./SpecialSubjectContent";
import CopyLessonDrawer from "./CopyLessonDrawer";
import {
  buildCopiedLessonValues,
  getAllowedExtraKeys,
  EVAL_ITEM_EVAL_TYPE,
} from "../utils/copyLessonValidation";
import { isDuplicateLesson } from "../utils/duplicateLessonCheck";
import HelpHyperLink from "../../../../unicomponents/HelpHyperLink";

export default function CreateUpdateLessonModal({
  settingData,
  termPeriodData,
  userData,
  schoolId,
  lessonSetting,
  setModalOpen,
  configMap,
  creUpdateLesson,
  setCreUpdateLesson,
  createOrUpdate,
  termIdModal,
  setTermIdModal,
}) {
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [tag, setTag] = useState("");
  const [selectedUserModal, setSelectedUserModal] = useState("");
  const [evalAreaWeights, setEvalAreaWeights] = useState([]);
  const [specialContentDrawerOpen, setSpecialContentDrawerOpen] =
    useState(false);
  // const [termIdModal, setTermIdModal] = useState("");
  //수업 복사 관련 상태 (생성일 때만 사용)
  const [copyDrawerOpen, setCopyDrawerOpen] = useState(false);
  const [copySource, setCopySource] = useState(null);
  const [copyOptions, setCopyOptions] = useState({
    lessonPlan: false,
    survey: false,
  });
  const [copyWarnings, setCopyWarnings] = useState([]);
  const { t } = useTranslation();

  const {
    lessonsQuery: { data: lessonsData },
    createLesson,
    copyLesson,
    updateLesson,
    deleteLesson,
  } = useLessons({
    schoolid: schoolId,
  });

  const {
    tagListByEntityQuery: { isLoading, data: tagList },
  } = useTagList({
    schoolid: schoolId,
    entity_type: "lessons",
  });

  const {
    flexibleDataQuery: { data: flexibleData },
  } = useFlexibleData({
    schoolid: schoolId,
    main_category: "schoolSetting",
  });

  const {
    flexibleDataQuery: { data: achievementFlexibleData },
  } = useFlexibleData({
    schoolid: schoolId,
    main_category: "convert100",
    sub_category: "achievement",
  });

  const { handleToastCenterTop, setToastConfirmModalState, setIsLoadingModal } =
    useUIContext();
  const { user, hasPermission } = useAuthContext();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (lessonSetting) {
      // console.log("lessonSetting", lessonSetting);
      const eval_area_weights = lessonSetting.filter(
        (setting) => setting.item_code === "evalArea100",
      )[0]?.detailed_setting;
      if (eval_area_weights) {
        setEvalAreaWeights(eval_area_weights);
      }
    }
  }, [configMap, lessonSetting]);

  useEffect(() => {
    if (!creUpdateLesson.evaluation_type && lessonSetting) {
      const thisSetting = lessonSetting.find(
        (r) => r.item_code === "evalMethod",
      );
      if (thisSetting && thisSetting.detailed_setting) {
        const firstOption = thisSetting.detailed_setting[0]; // 첫 번째 설정
        setCreUpdateLesson((prevLesson) => ({
          ...prevLesson,
          evaluation_type: firstOption,
        }));
      }
    }
  }, [creUpdateLesson.evaluation_type, lessonSetting, setCreUpdateLesson]);

  useEffect(() => {
    if (userData && user) {
      if (user.role === "teacher") {
        if (creUpdateLesson?.teachers?.length < 1) {
          setCreUpdateLesson((creUpdateLesson) => ({
            ...creUpdateLesson,
            teachers: [{ tname: user.fullname, username: user.username }],
          }));
          setSelectedUserModal(user.username);
          return;
        }
      }
      setSelectedUserModal(creUpdateLesson?.teachers[0]?.username || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCreUpdateLesson, user, userData]);

  useEffect(() => {
    if (!termIdModal && termIdModal.length === 0) {
      if (termPeriodData && creUpdateLesson?.school_year_id) {
        setTermIdByToday(
          termPeriodData,
          setTermIdModal,
          creUpdateLesson?.school_year_id,
        );
      }
    }
    setCreUpdateLesson((prev) => ({
      ...prev,
      term_id: termIdModal,
    }));
  }, [
    termPeriodData,
    termIdModal,
    setCreUpdateLesson,
    creUpdateLesson?.school_year_id,
    setTermIdModal,
  ]);

  const buildEmptyLesson = () => ({
    eval_area_weights: null,
    evaluation_type: "",
    extra_attributes: null,
    hierarchy_one: "",
    hierarchy_two: "",
    hierarchy_three: "",
    lesson_hours: "",
    school_year_id: "",
    schoolid: schoolId,
    subject_name: "",
    tags: [],
    teachers: [],
    term_id: "",
  });

  const clearCopyState = () => {
    setCopySource(null);
    setCopyOptions({ lessonPlan: false, survey: false });
    setCopyWarnings([]);
    setCopyDrawerOpen(false);
  };

  //복사 결과를 사용자가 확인할 수 있게 요약 문구로 만든다
  const buildCopyResultMessage = (response) => {
    const result = response?.copied ? response : response?.data || {};
    const copied = result?.copied || {};
    const parts = [];

    const countUnit = t("common.labels.countUnit") || "개";

    if (copied.evalItems)
      parts.push(
        `${t("teacher.lessonRelated.evalItem") || "평가항목"} ${
          copied.evalItems
        }${countUnit}`,
      );
    if (copied.lessonPlan)
      parts.push(t("teacher.lessonRelated.copyLessonPlan") || "수업계획서");
    if (copied.surveyQuestions)
      parts.push(
        `${
          t("teacher.lessonRelated.copySurveyQuestions") || "설문 추가질문"
        } ${copied.surveyQuestions}${countUnit}`,
      );

    let message =
      t("teacher.lessonRelated.copyCompleted") || "수업 복사가 완료되었습니다.";
    if (parts.length > 0) message += ` (${parts.join(", ")})`;
    if (Array.isArray(result?.skipped) && result.skipped.length > 0)
      message += ` / ${
        t("teacher.lessonRelated.copySkipped") || "제외"
      }: ${result.skipped.join(", ")}`;

    return message;
  };

  //복사 저장. 수업 본체는 화면 최종값을 쓰고, 부속물만 원본에서 가져온다.
  const submitCopyLesson = () => {
    setIsLoadingModal(true);

    copyLesson.mutate(
      {
        schoolid: schoolId,
        source_lesson_id: copySource.id,
        newLesson: creUpdateLesson,
        options: {
          copyLessonPlan: copyOptions.lessonPlan,
          copySurveyQuestions: copyOptions.survey,
        },
      },
      {
        onSuccess: (response) => {
          setIsLoadingModal(false);
          setIsSaving(false);
          setModalOpen(false);
          clearCopyState();
          setCreUpdateLesson(buildEmptyLesson());
          handleToastCenterTop(
            buildCopyResultMessage(response),
            5000,
            "#28a745",
          );
        },
        onError: (error) => {
          setIsLoadingModal(false);
          setIsSaving(false);
          if (
            error.message ===
            "과정, 학년, 반, 수업이름, 교사가 동일한 수업이 이미 존재합니다."
          ) {
            handleToastCenterTop(t("teacher.lessonRelated.sameLesson"), 4000);
            return;
          }
          console.error(error);
          alert(t("common.messages.errorAlert") + error.message);
        },
      },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      creUpdateLesson.evaluation_type === "100점제" &&
      creUpdateLesson?.eval_area_weights === null
    ) {
      handleToastCenterTop(t("teacher.lessonRelated.weightMessage"));
      return;
    }

    if (creUpdateLesson?.eval_area_weights) {
      if (
        sumAllNumbersOfObject(creUpdateLesson.eval_area_weights).toString() !==
          "100" &&
        creUpdateLesson.evaluation_type === "100점제"
      ) {
        handleToastCenterTop(t("teacher.lessonRelated.weightSumMessage"));
        return;
      }
    }

    if (creUpdateLesson?.teachers && creUpdateLesson?.teachers?.length < 1) {
      handleToastCenterTop(t("teacher.lessonRelated.teacherMessage"));
      return;
    }

    setIsSaving(true);

    if (createOrUpdate === "create") {
      const checkOwner = creUpdateLesson.teachers.some(
        (teacher) => teacher.username === user.username,
      );
      if (!checkOwner && !hasPermission(null, "can_create")) {
        handleToastCenterTop(
          t("common.messages.ownerPermission") ||
            "본인 것 외 생성은 권한이 있는 사람만 생성할 수 있습니다.",
        );
        setIsSaving(false);
        return;
      }

      //서버 요청 전에 완전 동일 조건(학년도·과정·학년·반·학기·수업명·교사)의 수업이
      //이미 있는지 먼저 막는다. copy 저장은 서버가 항상 400을 주는 게 아니라
      //(재시도 멱등 처리 때문에) 이미 존재하는 수업을 성공으로 착각해 되돌려줄 수 있어서
      //일반 생성과 동일하게 프론트에서 먼저 검증한다.
      if (isDuplicateLesson(creUpdateLesson, lessonsData)) {
        handleToastCenterTop(t("teacher.lessonRelated.sameLesson"), 4000);
        setIsSaving(false);
        return;
      }

      //복사 원본이 있으면 평가항목/계획서/설문까지 한 번에 처리하는 copy로 보낸다
      if (copySource) {
        submitCopyLesson();
        return;
      }

      createLesson.mutate(creUpdateLesson, {
        onSuccess: (successMessage) => {
          console.log(successMessage);
          setIsSaving(false);
          setModalOpen(false);
          setCreUpdateLesson({
            eval_area_weights: null,
            evaluation_type: "",
            extra_attributes: null,
            hierarchy_one: "",
            hierarchy_two: "",
            hierarchy_three: "",
            lesson_hours: "",
            school_year_id: "",
            schoolid: schoolId,
            subject_name: "",
            tags: [],
            teachers: [],
            term_id: "",
          });
        },
        onError: (error) => {
          setIsSaving(false);
          if (
            error.message ===
            "과정, 학년, 반, 수업이름, 교사가 동일한 수업이 이미 존재합니다."
          ) {
            handleToastCenterTop(t("teacher.lessonRelated.sameLesson"), 4000);
            return;
          } else {
            console.error(error); // 일단 콘솔에 에러를 출력합니다.
            console.error("위와 같은 에러가 났으니 고치삼");
            alert(t("common.messages.errorAlert") + error.message);
          }
        },
      });
    } else if (createOrUpdate === "update") {
      const checkOwner = creUpdateLesson.teachers.some(
        (teacher) => teacher.username === user.username,
      );
      if (!checkOwner && !hasPermission(null, "can_update")) {
        handleToastCenterTop(t("common.messages.ownerUpdatePermission"));
        setIsSaving(false);
        return;
      }

      updateLesson.mutate(creUpdateLesson, {
        onSuccess: (successMessage) => {
          setIsSaving(false);
          setModalOpen(false);
          setCreUpdateLesson({
            eval_area_weights: null,
            evaluation_type: "",
            extra_attributes: null,
            hierarchy_one: "",
            hierarchy_two: "",
            hierarchy_three: "",
            lesson_hours: "",
            school_year_id: "",
            schoolid: schoolId,
            subject_name: "",
            tags: [],
            teachers: [],
            term_id: "",
          });
        },
        onError: (error) => {
          setIsSaving(false);
          if (
            error.message ===
            "과정, 학년, 반, 수업이름, 교사가 동일한 수업이 이미 존재합니다."
          ) {
            handleToastCenterTop(t("teacher.lessonRelated.sameLesson"), 4000);
            return;
          } else {
            console.error(error); // 일단 콘솔에 에러를 출력합니다.
            console.error("위와 같은 에러가 났으니 고치삼");
            alert(t("common.messages.errorAlert") + error.message);
          }
        },
      });
    } else {
      console.log("update, create 둘 다 아니면 뭐지?");
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
    clearCopyState();
    setCreUpdateLesson({
      eval_area_weights: null,
      evaluation_type: "",
      extra_attributes: null,
      hierarchy_one: "",
      hierarchy_two: "",
      hierarchy_three: "",
      lesson_hours: "",
      school_year_id: "",
      schoolid: schoolId,
      subject_name: "",
      tags: [],
      teachers: [],
      term_id: "",
    });
  };

  const handleDelete = (e) => {
    const { name } = e.target;
    const { id } = creUpdateLesson;

    if (name === "delete") {
      setConfirmDelete(true);
    } else {
      const checkOwner = creUpdateLesson.teachers.some(
        (teacher) => teacher.username === user.username,
      );
      if (!checkOwner && !hasPermission(null, "can_delete")) {
        handleToastCenterTop(t("common.messages.ownerDeletePermission"));
        return;
      }

      setToastConfirmModalState({
        visible: true,
        message: t("teacher.lessonRelated.deleteAlert"),
        onConfirm: () => {
          setIsDeleting(true);
          deleteLesson.mutate(id, {
            onSuccess: (successMessage) => {
              setCreUpdateLesson({
                eval_area_weights: null,
                evaluation_type: "",
                extra_attributes: null,
                hierarchy_one: "",
                hierarchy_two: "",
                hierarchy_three: "",
                lesson_hours: "",
                school_year_id: "",
                schoolid: schoolId,
                subject_name: "",
                tags: [],
                teachers: [],
                term_id: "",
              });
              setIsDeleting(false);
              setConfirmDelete(false);
              setModalOpen(false);
              queryClient.invalidateQueries(["lessons"]);
            },
            onError: (error) => {
              setIsDeleting(false);
              setConfirmDelete(false);
              console.error(error); // 일단 콘솔에 에러를 출력합니다.
              console.error("위와 같은 에러가 났으니 고치삼");
              alert(error.message);
            },
          });
        },
        onCancel: () => {
          setConfirmDelete(false);
        },
      });
    }
  };

  const handleModalChange = (e) => {
    const { name, value, id } = e.target;
    let formattedValue = value;

    if (name === "eval_area_weights" || name === "extra_attributes") {
      if (id === "evalItems") {
        // evalItems 배열 처리
        const currentEvalItems =
          creUpdateLesson?.extra_attributes?.evalItems || [];
        const isItemSelected = currentEvalItems.includes(value);
        if (!isItemSelected && value !== "") {
          formattedValue = {
            ...creUpdateLesson.extra_attributes,
            evalItems: [...currentEvalItems, value],
          };
        } else {
          return;
        }
      } else {
        // 기존 로직 (다른 extra_attributes 필드들)
        formattedValue = {
          ...creUpdateLesson[name],
          [id]: value,
        };
      }
    }

    if (name === "tags") {
      setTag(value);
      const newTag = { [value]: "3" };
      const isTagSelected = creUpdateLesson?.tags?.some((tag) =>
        tag.hasOwnProperty(value),
      );
      if (!isTagSelected && value !== "") {
        formattedValue = [...creUpdateLesson.tags, newTag];
      } else {
        return;
      }
    }

    //이제 선생님 해야 한다.

    if (name === "teachers") {
      const selectedOptionText = e.target.selectedOptions[0].text;
      setSelectedUserModal(value);
      const teachersArray = Array.isArray(creUpdateLesson.teachers)
        ? creUpdateLesson.teachers
        : [];
      const exists = teachersArray.some((r) => r.username === value);

      if (!exists && value) {
        const newTeacher = { username: value, tname: selectedOptionText };

        // Create a new array with the new teacher included
        formattedValue = [...teachersArray, newTeacher];
      } else {
        return;
      }
    }

    setCreUpdateLesson((creUpdateLesson) => ({
      ...creUpdateLesson,
      [name]: formattedValue,
    }));
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;

    // console.log("creUpdateLesson", creUpdateLesson);

    if (name === "0") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        school_year: selectedOptionText,
        school_year_id: value,
        hierarchy_one: "",
      }));

      setTermIdByToday(termPeriodData, setTermIdModal, value);
    }

    if (name === "1") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        hierarchy_one: value,
        hierarchy_two: "",
        hierarchy_three: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermIdModal,
        creUpdateLesson.school_year_id,
        value,
      );
    }

    if (name === "2") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        hierarchy_two: value,
        hierarchy_three: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermIdModal,
        creUpdateLesson.school_year_id,
        creUpdateLesson.hierarchy_one,
        value,
      );
    }

    if (name === "3") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        hierarchy_three: value,
      }));
    }

    if (name === "termDate") {
      setTermIdModal(value);
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        term_id: value,
      }));
    }

    // 아... 역시 교사를 가용한 모든 교사로 바꾸어야겠군 -> 바꾸었음
  };

  const handleClick = (value, name) => {
    if (name === "tags") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        tags: creUpdateLesson?.tags.filter((tag) => !tag.hasOwnProperty(value)),
      }));
    }

    if (name === "teachers") {
      setCreUpdateLesson((creUpdateLesson) => ({
        ...creUpdateLesson,
        teachers: creUpdateLesson.teachers.filter(
          (user) => user.username !== value,
        ),
      }));
    }
  };

  if (isLoading) return <div>Loading...</div>;

  const achievementOptions = Array.isArray(
    achievementFlexibleData?.[0]?.data_value,
  )
    ? achievementFlexibleData[0].data_value
        .map((item) => ({
          label: item?.label || "",
          rules: item?.rules || [],
        }))
        .filter((item) => item.label)
    : [];

  //원본 수업에서 "현재 설정에 존재하는 값"만 폼에 주입한다.
  //계층/학기/교사/학년도는 지금 선택된 값을 유지하기 위해 건드리지 않는다.
  const handleLoadCopySource = (sourceLesson, selectedOptions) => {
    const allowedExtraKeys = getAllowedExtraKeys({
      configMap,
      hasAchievementOptions: achievementOptions.length > 0,
      flexibleDataValue: flexibleData?.[0]?.data_value,
    });

    const { values, warnings } = buildCopiedLessonValues({
      sourceLesson,
      lessonSetting,
      allowedExtraKeys,
    });

    setCreUpdateLesson((prev) => ({ ...prev, ...values }));
    setCopySource({
      id: sourceLesson.id,
      subject_name: sourceLesson.subject_name,
      evaluation_type: sourceLesson.evaluation_type,
      label: `${sourceLesson.subject_name} (${sourceLesson.hierarchyTwo}-${sourceLesson.hierarchyThree})`,
    });
    setCopyOptions(selectedOptions);
    setCopyWarnings(warnings);
    setCopyDrawerOpen(false);

    handleToastCenterTop(
      `"${sourceLesson.subject_name}"${
        t("teacher.lessonRelated.copyLoaded") || " 을 불러왔습니다."
      }`,
      2000,
      "#28a745",
    );
  };

  const handleClearCopySource = () => {
    clearCopyState();
    handleToastCenterTop(
      t("teacher.lessonRelated.copyCleared") ||
        "복사를 해제했습니다. 일반 수업으로 생성됩니다.",
      2000,
    );
  };

  return (
    <>
      <div className="modal-container">
        <div
          className="modalForUnit"
          style={{
            width: "800px",
            maxHeight: "92vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <div className="modal-header mb-3 align-items-center gap-3 flex-shrink-0">
            <h3 className="mb-0">
              {createOrUpdate === "create"
                ? t("teacher.lessonRelated.createLesson")
                : t("teacher.lessonRelated.updateLesson")}
            </h3>
            {createOrUpdate === "create" && (
              <>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => setCopyDrawerOpen((prev) => !prev)}
                >
                  {copyDrawerOpen
                    ? `◀ ${t("teacher.lessonRelated.copyClose") || "복사 닫기"}`
                    : `📋 ${t("teacher.lessonRelated.copyLesson") || "수업 복사"}`}
                </button>
                <HelpHyperLink link={"https://youtu.be/rG7yA7YKCag"} />
              </>
            )}
          </div>

          {createOrUpdate === "create" && copySource && (
            <div
              className="alert alert-info d-flex align-items-center flex-wrap gap-2 py-2 px-3 mb-2 flex-shrink-0"
              style={{ fontSize: "0.9rem" }}
            >
              <strong>
                {t("teacher.lessonRelated.copySource") || "복사 원본"}:
              </strong>
              <span>{copySource.label}</span>
              {creUpdateLesson?.evaluation_type === EVAL_ITEM_EVAL_TYPE && (
                <span className="badge bg-secondary">
                  {t("teacher.lessonRelated.evalItem") || "평가항목"}
                </span>
              )}
              {copyOptions.lessonPlan && (
                <span className="badge bg-secondary">
                  {t("teacher.lessonRelated.copyLessonPlan") || "수업계획서"}
                </span>
              )}
              {copyOptions.survey && (
                <span className="badge bg-secondary">
                  {t("teacher.lessonRelated.copySurveyQuestions") ||
                    "설문 교사 추가질문"}
                </span>
              )}
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ms-auto"
                onClick={handleClearCopySource}
              >
                {t("teacher.lessonRelated.copyClear") || "복사 해제"}
              </button>
            </div>
          )}

          {copyWarnings.length > 0 && (
            <div
              className="alert alert-warning py-2 px-3 mb-2 flex-shrink-0"
              style={{
                fontSize: "0.85rem",
                overflowY: "auto",
                maxHeight: "20vh",
              }}
            >
              <ul className="mb-0 ps-3">
                {copyWarnings.map((warning, index) => (
                  <li key={index}>{warning}</li>
                ))}
              </ul>
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              minHeight: 0,
            }}
          >
            <div
              className="modal-content"
              style={{
                maxHeight: "none",
                flexGrow: 1,
                minHeight: 0,
                marginBottom: "1rem",
              }}
            >
              <table className="table text-center align-middle table-borderless">
                <tbody>
                  <tr>
                    <td style={{ width: "25%" }}>
                      <DropdownSchoolYear
                        settingData={settingData}
                        handleDropdownChange={handleDropdownChange}
                        schoolYearId={creUpdateLesson.school_year_id}
                        allYears={false}
                      />
                    </td>
                    <td style={{ width: "25%" }}>
                      <DropdownHierarchyOne
                        settingData={settingData}
                        handleDropdownChange={handleDropdownChange}
                        schoolYear={creUpdateLesson.school_year}
                        hierarchyOneId={creUpdateLesson.hierarchy_one}
                        hierarchyOneTitle={t("common.labels.whole")}
                        extraOption={true}
                        extraOptionTitle={t("common.labels.schoolStage")}
                        required={true}
                      />
                    </td>
                    <td style={{ width: "25%" }}>
                      <DropdownHierarchyTwo
                        settingData={settingData}
                        handleDropdownChange={handleDropdownChange}
                        schoolYear={creUpdateLesson.school_year}
                        hierarchyOneId={creUpdateLesson.hierarchy_one}
                        hierarchyTwoId={creUpdateLesson.hierarchy_two}
                        hierarchyTwoTitle={t("common.labels.whole")}
                        extraOption={true}
                        extraOptionTitle={t("common.labels.studentYear")}
                        required={true}
                      />
                    </td>
                    <td style={{ width: "25%" }}>
                      <DropdownHierarchyThree
                        settingData={settingData}
                        handleDropdownChange={handleDropdownChange}
                        schoolYear={creUpdateLesson.school_year}
                        hierarchyTwoId={creUpdateLesson.hierarchy_two}
                        hierarchyThreeId={creUpdateLesson.hierarchy_three}
                        hierarchyThreeTitle={t("common.labels.whole")}
                        extraOption={true}
                        extraOptionTitle={t("common.labels.class")}
                        required={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <DropdownTermDate
                        termPeriodData={termPeriodData}
                        handleDropdownChange={handleDropdownChange}
                        termId={termIdModal}
                        schoolYearId={creUpdateLesson.school_year_id}
                        hierarchyOneId={creUpdateLesson.hierarchy_one}
                        hierarchyTwoId={creUpdateLesson.hierarchy_two}
                        required={true}
                      />
                    </td>
                    <td>
                      <DropdownUniqueUsersInDisplayData
                        displayData={userData}
                        displayKey={"fullname"}
                        valueKey={"username"}
                        uniqueKey={"username"}
                        sortKey={"fullname"}
                        isDesc={false}
                        handleDropdownChange={handleModalChange}
                        selectedUser={selectedUserModal}
                        selectName="teachers"
                        dropdownTitle={t("teacher.lessonRelated.selectTeacher")}
                        required={true}
                      />
                    </td>
                    <td colSpan={2} className="text-start">
                      {Array.isArray(creUpdateLesson?.teachers) &&
                        creUpdateLesson?.teachers?.map((user, index) => (
                          <span key={index}>
                            {user.tname}
                            <MdOutlineCancel
                              role="button"
                              onClick={() => {
                                handleClick(user.username, "teachers");
                              }}
                            />
                          </span>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("teacher.lessonRelated.subjectName")}</td>
                    <td colSpan={3}>
                      <input
                        type="text"
                        name="subject_name"
                        className="form-control"
                        value={creUpdateLesson?.subject_name || ""}
                        onChange={handleModalChange}
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.labels.classHours")}</td>
                    <td>
                      <input
                        type="number"
                        name="lesson_hours"
                        className="form-control"
                        value={creUpdateLesson?.lesson_hours || ""}
                        onChange={handleModalChange}
                        required
                      />
                    </td>
                    <td>{t("teacher.lessonRelated.evaluationType")}</td>
                    <td>
                      <select
                        className="form-control"
                        name="evaluation_type"
                        value={creUpdateLesson?.evaluation_type || ""}
                        required
                        onChange={handleModalChange}
                      >
                        {lessonSetting?.filter(
                          (r) => r.item_code === "evalMethod",
                        ).length > 0 &&
                          lessonSetting
                            ?.filter((r) => r.item_code === "evalMethod")[0]
                            ?.detailed_setting?.map((setting, index) => (
                              <option key={index} value={setting}>
                                {setting}
                              </option>
                            ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <select
                        className="form-control"
                        name="tags"
                        value={tag}
                        onChange={handleModalChange}
                      >
                        <option value="">{t("common.labels.selectTag")}</option>
                        {tagList &&
                          tagList[0]?.tags.map((tag, index) => (
                            <option key={index} value={tag}>
                              {tag}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td colSpan={3} className="text-start">
                      {Array.isArray(creUpdateLesson?.tags) &&
                        creUpdateLesson?.tags?.map((tagObj, index) => {
                          const [tagKey] = Object.keys(tagObj); // 객체에서 키 추출
                          return (
                            <span key={index}>
                              {tagKey}
                              <MdOutlineCancel
                                role="button"
                                onClick={() => {
                                  handleClick(tagKey, "tags"); // 태그 삭제 함수 호출
                                }}
                              />
                            </span>
                          );
                        })}
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* 지정평가영역 선택 */}
              {creUpdateLesson?.evaluation_type === "지정평가영역" && (
                <table className="table text-center align-middle table-borderless">
                  <tbody>
                    <tr>
                      <td style={{ width: "25%" }}>
                        <select
                          className="form-control"
                          name="extra_attributes"
                          id="evalItems"
                          value=""
                          onChange={handleModalChange}
                        >
                          <option value="">평가영역 선택</option>
                          {lessonSetting
                            ?.find((r) => r.item_code === "evalMethod")
                            ?.extra_attributes?.evalItems?.filter(
                              (item) => item.active,
                            )
                            ?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.evalItem}
                              </option>
                            ))}
                        </select>
                      </td>
                      <td colSpan={3} className="text-start">
                        {Array.isArray(
                          creUpdateLesson?.extra_attributes?.evalItems,
                        ) &&
                          creUpdateLesson?.extra_attributes?.evalItems?.map(
                            (itemId, index) => {
                              const evalItem = lessonSetting
                                ?.find((r) => r.item_code === "evalMethod")
                                ?.extra_attributes?.evalItems?.find(
                                  (item) => item.id === itemId,
                                );
                              return evalItem ? (
                                <span key={index} className="me-2">
                                  {evalItem.evalItem}
                                  <MdOutlineCancel
                                    role="button"
                                    onClick={() => {
                                      handleClick(itemId, "evalItems");
                                    }}
                                  />
                                </span>
                              ) : null;
                            },
                          )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}

              {(creUpdateLesson?.evaluation_type === "100점제" ||
                creUpdateLesson?.evaluation_type === "커스텀") && (
                <table className="table text-center align-middle mt-1 mb-3">
                  <tbody>
                    <tr>
                      <th style={{ width: "20%" }}>
                        {t("teacher.lessonRelated.evalAreaWeights")}
                      </th>
                      {evalAreaWeights &&
                        evalAreaWeights.map((weight) => (
                          <th key={weight}>{weight}</th>
                        ))}
                      <th style={{ width: "15%" }}>
                        {t("teacher.lessonRelated.sum")}
                      </th>
                    </tr>
                    <tr>
                      <td>{t("teacher.lessonRelated.weight")}(%)</td>
                      {evalAreaWeights &&
                        evalAreaWeights.map((weight, index) => (
                          <td key={index}>
                            <input
                              className="form-control m-0 p-1"
                              type="number"
                              name="eval_area_weights"
                              onChange={handleModalChange}
                              id={weight}
                              value={
                                creUpdateLesson?.eval_area_weights?.[weight] ??
                                ""
                              }
                            />
                          </td>
                        ))}
                      <td>
                        {creUpdateLesson?.eval_area_weights
                          ? sumAllNumbersOfObject(
                              creUpdateLesson.eval_area_weights,
                            )
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}

              <div className="row g-3 text-center align-middle mb-2">
                {configMap.subjectSort !== "미사용" && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("common.labels.category")}
                      </div>
                      <div className="flex-grow-1">
                        {lessonSetting && creUpdateLesson && (
                          <RenderExtraAttributesSelect
                            lessonSetting={lessonSetting}
                            itemCode="subjectSort"
                            creUpdateLesson={creUpdateLesson}
                            setCreUpdateLesson={setCreUpdateLesson}
                            handleModalChange={handleModalChange}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {Array.isArray(flexibleData?.[0]?.data_value?.subjectSort2) &&
                  flexibleData[0].data_value.subjectSort2.length > 0 && (
                    <div className="col-12 col-md-6">
                      <div className="d-flex align-items-center gap-2">
                        <div className="flex-shrink-0" style={{ width: "30%" }}>
                          {t("common.labels.category2") || "구분2"}
                        </div>
                        <div className="flex-grow-1">
                          <select
                            className="form-control"
                            name="extra_attributes"
                            id="subjectSort2"
                            value={
                              creUpdateLesson?.extra_attributes
                                ?.subjectSort2 || ""
                            }
                            onChange={handleModalChange}
                          >
                            <option value=""></option>
                            {flexibleData[0].data_value.subjectSort2.map(
                              (setting) => (
                                <option key={setting} value={setting}>
                                  {setting}
                                </option>
                              ),
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                {configMap.subjectCategory !== "미사용" && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("teacher.lessonRelated.subjectCategory")}
                      </div>
                      <div className="flex-grow-1">
                        <RenderExtraAttributesSelect
                          lessonSetting={lessonSetting}
                          itemCode="subjectCategory"
                          creUpdateLesson={creUpdateLesson}
                          setCreUpdateLesson={setCreUpdateLesson}
                          handleModalChange={handleModalChange}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {configMap.subjectCode !== "미사용" && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("teacher.lessonRelated.subjectCode")}
                      </div>
                      <div className="flex-grow-1">
                        <RenderExtraAttributesSelect
                          lessonSetting={lessonSetting}
                          itemCode="subjectCode"
                          creUpdateLesson={creUpdateLesson}
                          setCreUpdateLesson={setCreUpdateLesson}
                          handleModalChange={handleModalChange}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {configMap.subjectOrder !== "미사용" && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("teacher.lessonRelated.subjectOrder")}
                      </div>
                      <div className="flex-grow-1">
                        {lessonSetting?.find(
                          (r) => r.item_code === "subjectOrder",
                        ) ? (
                          <input
                            className="form-control"
                            type="number"
                            name="extra_attributes"
                            value={
                              creUpdateLesson?.extra_attributes?.subjectOrder ||
                              ""
                            } // 상태 값이 안전하게 접근
                            id="subjectOrder"
                            required={
                              lessonSetting?.find(
                                (r) => r.item_code === "subjectOrder",
                              ).saved_setting === "필수"
                                ? true
                                : false
                            }
                            onChange={handleModalChange}
                          />
                        ) : (
                          <div>{t("common.messages.reportToAdmin")}</div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {configMap.creditHour !== "미사용" && configMap.creditHour && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("teacher.lessonRelated.creditHour")}
                      </div>
                      <div className="flex-grow-1">
                        {/* {lessonSetting?.find(
                          (r) => r.item_code === "creditHour"
                        ) ? ( */}
                        <input
                          className="form-control"
                          type="number"
                          name="extra_attributes"
                          value={
                            creUpdateLesson?.extra_attributes?.creditHour || ""
                          } // 상태 값이 안전하게 접근
                          id="creditHour"
                          required={
                            lessonSetting?.find(
                              (r) => r.item_code === "creditHour",
                            ).saved_setting === "필수"
                              ? true
                              : false
                          }
                          onChange={handleModalChange}
                        />
                        {/* ) : (
                          <div>{t("common.messages.reportToAdmin")}</div>
                        )} */}
                      </div>
                    </div>
                  </div>
                )}

                {achievementOptions.length > 0 && (
                  <div className="col-12 col-md-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0" style={{ width: "30%" }}>
                        {t("teacher.lessonRelated.achievement") || "성취도"}
                      </div>
                      <div className="flex-grow-1">
                        <select
                          className="form-control"
                          name="extra_attributes"
                          value={
                            creUpdateLesson?.extra_attributes?.achievement || ""
                          } // 상태 값이 안전하게 접근
                          id="achievement"
                          onChange={handleModalChange}
                        >
                          <option value="">
                            {t("teacher.lessonRelated.selectAchievement") ||
                              "성취도 선택"}
                          </option>
                          {achievementOptions.map((achievement) => (
                            <option
                              key={achievement.label}
                              value={achievement.label}
                            >
                              {achievement.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {configMap.subjectContent !== "미사용" && (
                  <div className="col-12">
                    <div className="d-flex align-items-start gap-2">
                      <div
                        className="flex-shrink-0 pt-2"
                        style={{ width: "15%" }}
                      >
                        {t("teacher.lessonRelated.subject")}
                        <br />
                        {t("teacher.lessonRelated.commonContent") ||
                          "과목 공통내용"}
                      </div>
                      <div className="flex-grow-1">
                        <textarea
                          type="text"
                          name="extra_attributes"
                          className="form-control"
                          id="subjectContent"
                          onChange={handleModalChange}
                          rows={4}
                          required={
                            lessonSetting?.find(
                              (r) => r.item_code === "subjectContent",
                            )?.saved_setting === "필수"
                              ? true
                              : false
                          }
                          value={
                            creUpdateLesson?.extra_attributes?.subjectContent ||
                            ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}

                {flexibleData &&
                  flexibleData.length > 0 &&
                  flexibleData[0].data_value?.secondSubjectContent && (
                    <div className="col-12">
                      <div className="d-flex align-items-start gap-2">
                        <div
                          className="flex-shrink-0 pt-2"
                          style={{ width: "15%" }}
                        >
                          두번째
                          <br />
                          공통내용
                        </div>
                        <div className="flex-grow-1">
                          <textarea
                            type="text"
                            name="extra_attributes"
                            className="form-control"
                            id="secondSubjectContent"
                            onChange={handleModalChange}
                            rows={4}
                            value={
                              creUpdateLesson?.extra_attributes
                                ?.secondSubjectContent || ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {flexibleData &&
                  flexibleData.length > 0 &&
                  flexibleData[0].data_value?.specialSubjectContent && (
                    <div className="col-12 text-end">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setSpecialContentDrawerOpen(true)}
                      >
                        {t("teacher.lessonRelated.specialSubjectContent") ||
                          "배움내용 설정"}
                      </button>
                    </div>
                  )}
              </div>
            </div>
            <div className="modal-footer flex-shrink-0">
              {isDeleting ? (
                <button type="button" className="btn btn-danger" disabled>
                  {t("common.status.deleting")}..
                </button>
              ) : (
                <button
                  type="button"
                  className={
                    confirmDelete ? "btn btn-danger" : "btn btn-warning"
                  }
                  name={confirmDelete ? "confirm" : "delete"}
                  onClick={handleDelete}
                >
                  {confirmDelete
                    ? t("common.labels.doDelete")
                    : t("common.labels.delete") || "삭제"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                {t("common.labels.cancel") || "취소"}
              </button>
              {isSaving ? (
                <button className="btn btn-primary" disabled>
                  {t("common.status.saving")}..
                </button>
              ) : (
                <button type="submit" className="btn btn-primary">
                  {copySource
                    ? t("teacher.lessonRelated.copyAndCreate") ||
                      "복사하여 생성"
                    : t("common.labels.doSave")}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      {/* 수업 복사 Drawer (생성일 때만) */}
      {createOrUpdate === "create" && copyDrawerOpen && (
        <CopyLessonDrawer
          settingData={settingData}
          termPeriodData={termPeriodData}
          schoolId={schoolId}
          initialSchoolYearId={creUpdateLesson.school_year_id}
          onLoad={handleLoadCopySource}
          onClose={() => setCopyDrawerOpen(false)}
        />
      )}

      {/* 배움내용 설정 Drawer */}
      {specialContentDrawerOpen && (
        <SpecialSubjectContent
          creUpdateLesson={creUpdateLesson}
          setCreUpdateLesson={setCreUpdateLesson}
          onClose={() => setSpecialContentDrawerOpen(false)}
        />
      )}
    </>
  );
}

function RenderExtraAttributesSelect({
  lessonSetting,
  itemCode,
  creUpdateLesson,
  setCreUpdateLesson,
  handleModalChange,
}) {
  const thisSetting = lessonSetting?.find((r) => r.item_code === itemCode);

  const isRequired = thisSetting?.saved_setting === "필수";

  useEffect(() => {
    if (
      isRequired &&
      (!creUpdateLesson.extra_attributes ||
        !creUpdateLesson.extra_attributes[itemCode])
    ) {
      const firstOption = thisSetting?.detailed_setting[0]; // 첫 번째 설정
      setCreUpdateLesson((prevLesson) => ({
        ...prevLesson,
        extra_attributes: {
          ...prevLesson.extra_attributes,
          [itemCode]: firstOption, // 첫 번째 옵션을 기본값으로 설정
        },
      }));
    }
  }, [
    isRequired,
    itemCode,
    thisSetting?.detailed_setting,
    creUpdateLesson.extra_attributes,
    setCreUpdateLesson,
  ]);

  if (!thisSetting) {
    return <div>관리자문의</div>; // 설정이 없을 경우 메시지 출력
  }

  const selectValue = creUpdateLesson?.extra_attributes?.[itemCode] || ""; // Optional chaining 사용

  return (
    <React.Fragment>
      <select
        className="form-control"
        name="extra_attributes"
        value={selectValue} // 상태 값이 안전하게 접근
        id={itemCode}
        required={isRequired}
        onChange={handleModalChange}
      >
        {!isRequired && <option value=""></option>}
        {thisSetting.detailed_setting.map((setting) => (
          <option key={setting} value={setting}>
            {setting}
          </option>
        ))}
      </select>
    </React.Fragment>
  );
}

/* 예전 내가 혼자 만들었던 것 기록용 (저 위에 것은 챗지피티가 컴포넌트로 만들라고 해서 따라 한 것... 내부함수로 간단히 하고 싶었는데 컴포넌트가 더 좋다고 함)


                          <select
                            className="form-control"
                            name="extra_attributes"
                            value={creUpdateLesson?.extra_attributes || ""}
                            id="subjectCategory"
                            required
                            onChange={handleModalChange}
                          >
                            {lessonSetting?.filter(
                              (r) => r.item_code === "subjectCategory"
                            ).length > 0 &&
                              lessonSetting
                                ?.filter(
                                  (r) => r.item_code === "subjectCategory"
                                )[0]
                                .detailed_setting.map((setting, index) => (
                                  <option key={index} value={setting}>
                                    {setting}
                                  </option>
                                ))}
                          </select>
*/
